@if (devMode) {
  <dev-tools />
}
<div (click)="resetInactivityTimer()" (keyup)="handleKeyUp($event)" (dblclick)="swallowDblClick($event)">
  <div class="aspect-ratio-box">
    <div class="aspect-ratio-box-inside">
      <div class="flexbox-centering">
        <router-outlet></router-outlet>
        @if (showPleaseWaitDialog) {
          <please-wait-dialog></please-wait-dialog>
        }
        @if (showAssetLoadingDialog) {
          <asset-loading-dialog (onLogoutButtonClick)="logout()" (onRetryButtonClick)="reloadAssets()"></asset-loading-dialog>
        }
      </div>
    </div>
  </div>
</div>
